/* Koforto 内衣落地页（product.bra-landing）交互：替代旧主题缺失的 bra-landing.js
 * 1) 购买区图库：点缩略图换主图   2) 尺码表弹窗   3) 价格行随选择器档位变化
 * 4) 手机底部悬浮按钮：滚过首屏出现，到购买区隐藏   5) data-year / data-month
 */
(() => {
  const fmt = (cents, f) => {
    const n = (cents / 100).toFixed(2), [i, d] = n.split('.');
    const comma = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (f || '£{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) =>
      k === 'amount_no_decimals' ? comma : k === 'amount_with_comma_separator' ? `${i}.${d}`.replace('.', ',') : `${comma}.${d}`);
  };

  // 1) 图库
  document.querySelectorAll('[data-gallery]').forEach((g) => {
    const main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('.thumbs button[data-src]').forEach((b) => b.addEventListener('click', () => {
      g.querySelectorAll('.thumbs button').forEach((x) => x.removeAttribute('aria-current'));
      b.setAttribute('aria-current', 'true');
      let img = main.querySelector('img');
      if (!img) { main.querySelectorAll('span').forEach((x) => x.remove()); img = document.createElement('img'); main.appendChild(img); main.classList.add('has-img'); }
      img.removeAttribute('srcset'); img.src = b.dataset.src;
    }));
  });

  // 2) 尺码表
  const dlg = document.querySelector('[data-sizeguide]');
  document.querySelectorAll('[data-open-sizeguide]').forEach((b) => b.addEventListener('click', () => dlg && dlg.showModal && dlg.showModal()));
  document.querySelectorAll('[data-close-sizeguide]').forEach((b) => b.addEventListener('click', () => dlg && dlg.close()));
  if (dlg) dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });

  // 3) 价格行
  document.addEventListener('kf:change', (e) => {
    const box = e.target.closest('.buybox'); if (!box) return;
    const row = box.querySelector('[data-bl-price]'); if (!row) return;
    const vs = (e.detail && e.detail.variants) || []; const now = e.detail.total || 0;
    // 划线价规则与选择器一致（kp_strike：price = 单价×件数；compare = 原价 compare-at）
    const st = e.target.d && e.target.d.strike;
    const was = vs.reduce((a, v) => a + (v ? (st === 'price' ? v.price : Math.max(v.compare || 0, v.price)) : 0), 0);
    const f = e.target.d && e.target.d.moneyFormat;
    row.querySelector('[data-total]').textContent = fmt(now, f);
    const s = row.querySelector('[data-compare]'), sv = row.querySelector('[data-save]');
    if (s) { s.textContent = fmt(was, f); s.hidden = !(was > now); }
    if (sv) { const pct = was > now ? Math.floor(((was - now) / was) * 100) : 0; sv.hidden = pct < 1; sv.textContent = (sv.dataset.tpl || 'Save [pct]%').replace('[pct]', pct); }
  });

  // 4) 手机底部悬浮按钮
  const bar = document.querySelector('[data-bl-sticky]');
  const after = document.querySelector('.hero');
  const hides = document.querySelectorAll('#buy, .final');
  if (bar && after && 'IntersectionObserver' in window) {
    let past = false; const vis = new Set();
    const upd = () => bar.classList.toggle('show', past && vis.size === 0);
    new IntersectionObserver(([e]) => { past = !e.isIntersecting && e.boundingClientRect.top < 0; upd(); }).observe(after);
    const io = new IntersectionObserver((es) => { es.forEach((e) => (e.isIntersecting ? vis.add(e.target) : vis.delete(e.target))); upd(); });
    hides.forEach((h) => io.observe(h));
  }

  // 5) 日期
  document.querySelectorAll('[data-year]').forEach((e) => (e.textContent = new Date().getFullYear()));
  document.querySelectorAll('[data-month]').forEach((e) => (e.textContent = new Date().toLocaleDateString(document.documentElement.lang || 'en-GB', { month: 'long', year: 'numeric' })));
})();
